import { defineAsyncComponent } from 'vue'

export default (app: any) => {
	app.component('commission-optimizer', defineAsyncComponent(() => import(/* webpackChunkName: "CommissionOptimizer" */ './CommissionOptimizer.vue')))
}
